

var origin = { x: 0, y: 0 };

export var noMovement = {
  displaced: [],
  amount: origin,
  isBeyondStartPosition: false
};

var noImpact = {
  movement: noMovement,
  direction: null,
  destination: null
};

export default noImpact;


//////////////////
// WEBPACK FOOTER
// ../~/react-beautiful-dnd/esm/state/no-impact.js
// module id = 320
// module chunks = 1